import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { HubFrequentDriverModel } from '../../store/state/administration';
import { IconNames } from '../../common/constants/icon-names';

@Component({
  selector: 'ui-driver-autocomplete',
  templateUrl: './driver-autocomplete.component.html',
  styleUrls: ['./driver-autocomplete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DriverAutocompleteComponent<T extends HubFrequentDriverModel> {
  @Input() values: T[];
  @Input() fieldLabel: string;
  @Input() fieldControl: FormControl<T>;
  @Input() testId: string;
  @Input() controlName: string;
  @Input() isReadonly?: boolean;
  @Input() needAutocomplete?: string;
  @Input() isSelect?: boolean = false;
  @Input() required = false;

  @Output() driverSelected: EventEmitter<T> = new EventEmitter<T>(null);
  @Output() clearButtonClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>(null);

  iconNames = IconNames;

  onDriverSelected(value: T): void {
    this.driverSelected.emit(value);
  }

  onClearButtonClick(event: MouseEvent): void {
    this.clearButtonClick.emit(event);
  }

  getLabelSuffix(): string {
    return this.required ? ' *' : '';
  }
}
